module.exports = __webpack_public_path__ + "fonts/fontawesome.fee66e71.woff";